var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-admin-reports-main__table-cell page-admin-reports-main__table-cell-datetime"},[_c('span',[_vm._v(_vm._s(_vm.formattedDate))]),_c('span',[_vm._v(_vm._s(_vm.formattedTime))])])}
var staticRenderFns = []

export { render, staticRenderFns }